import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DefaultHeaders, wijimoIdsList, WjGridSaveModel } from "../models";
import { CommonService, UserService } from "../services";
import { CommonUtil } from "./common.util";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import * as wjcGrid from "@grapecity/wijmo.grid";

@Injectable({
    providedIn: "root"
})

export class WijimoUtil {

    _wjSavedData$: BehaviorSubject<any> = new BehaviorSubject(null);
    wjSavedData$ = this._wjSavedData$.asObservable();
    private isExporting = false; // Prevent multiple export operations
    private readonly DEFAULT_EXPORT_DELAY_MS = 500; // Default delay to prevent accidental double-clicks

    constructor(private _commonSer: CommonService, private _userService: UserService, private _comnUtil: CommonUtil) {
    }

    async storeWjSavedData(data) {
        this._wjSavedData$.next(data);
    }

    patchDefWidth(flex, wijimoKey, storedWJData?: any) {
        const storedWJ = storedWJData ? storedWJData : this.getWJSavedData(wijimoKey);
        if (flex && flex.columns && flex.columns.length && storedWJ && wijimoKey !== "intakeQueueWjList" &&  wijimoKey !== "DURValNewRxWJ") {
            flex.columns.map((pCol) => {
                const col = storedWJ.find(v => v["header"] === pCol["header"]);
                if (col) {
                    pCol["width"] = col["width"];
                }
            });
        }
    }

    patchDefHeader(wijimoKey, storedWJ?: any, getActionCols: boolean = false , gridWidth?: number) {
        const storedWJData = (storedWJ && storedWJ.length) ? storedWJ : this.getWJSavedData(wijimoKey);
        var headers = [];
        let widthData = 0;
        let avgWidth = 0;
        if(storedWJData && storedWJData.length) {
             headers = storedWJData.map(v => {
                const k = {};
                k["hName"] = v.header;
                k["isVisible"] = v.isVisible;
                k["width"] = v.width;
                if(k["isVisible"]){
                    widthData += v.width;
                }
                k["minWidth"] = v.minWidth
                return k;
            });
            if(gridWidth && widthData && gridWidth > widthData){
                let diffWidth = (gridWidth-widthData)-8;
                avgWidth = diffWidth/storedWJData.length;
                headers = storedWJData.map(v => {
                    const k = {};
                    k["hName"] = v.header;
                    k["isVisible"] = v.isVisible;
                    k["width"] = v.width + avgWidth;
                    k["minWidth"] = v.minWidth
                    return k;
                });
            } 
        }
        if(!getActionCols) {
            const excludeheader = this.setExcludeCols(wijimoKey);
            excludeheader.map(v => {
                const index = headers.findIndex(i => i["hName"] === v);
                if (index > -1) {
                    headers.splice(index, 1);
                }
            });
        }
        return headers;
    }

    setExcludeCols(wijimoKey) {
        const excludeheader =  [" ", "",  null, "Action", "Actions", "Select","SELECT", "View Docs", "Tag", "ACTIONS", "View Trans Result", "IsDeleted?", "PA Status"];
        if (wijimoKey === "erxListingWJ") {
            excludeheader.push("Process");
        } else if (wijimoKey === "reviewRxVerfWJ" || wijimoKey === "reviewdrugVerfWJ") {
            excludeheader.push("Edit Rx");
            excludeheader.push("History");
        } else if (wijimoKey === "reviewFollowupWJ") {
            excludeheader.push("Tag History");
        } else if (wijimoKey === "controlResubmitListWJ" || wijimoKey === "rxBasicDisplayListWJ") {
            excludeheader.push("Status");
        }
        return excludeheader;
    }

    setPickerExcludeCols(wijimoKey) {
        const pickerExclude = [];
        if (wijimoKey === "remittanceDataSetListWJ") {
            pickerExclude.push("MFP Amt Approved");
            pickerExclude.push("MFP Reimbursements");
            pickerExclude.push("MFP Diff Amount");
            pickerExclude.push("MFP Status");
        } else if (wijimoKey === "erxExceptionListWJ") {
            pickerExclude.push("Pharmacy Npi");
        }
        return pickerExclude;
    }

   async getWJSavedData(wijimoKey, type?: boolean, frmRxHist?: boolean) {
        const savedData = this._commonSer.wjSavedList$["source"]["value"];
        let result = null;
        if(frmRxHist && wijimoKey && (wijimoKey === "labelQueueDisplayListWJ" || wijimoKey === "forGroupViewWj")) {
            result = await this.getDefaultHead(wijimoKey);
        }
         else if (savedData && savedData.length && wijimoKey !== 'erxListingWJRequestView' && wijimoKey !== 'RxsTransferIn' && wijimoKey !== 'drugRequesteDetails') {
            const data = savedData.find(v => v["WijmoKey"] === wijimoKey && v["UserId"] === +this._userService.getToken("UserId"));
            if (data) {
                result = type ? data : JSON.parse(data["ColumnOrder"]);
                const defaultHeaders = this.getDefaultHead(wijimoKey);
                const defaultHeadersForReturn: any  = [];
                result.map((item: any) => {
                    const existHeader = defaultHeaders ? defaultHeaders.filter((item1: any)=> {   return (item1["header"] === item["header"])  }) : [];
                            if(existHeader && existHeader.length) {
                                defaultHeadersForReturn.push(item);
                            }
                });
                result = defaultHeadersForReturn;
                const defHead = this.getDefaultHead(wijimoKey);
                if (defHead && result && defHead.length !== result.length) {
                    const missedData = defHead.filter(h => result.findIndex(r => r["header"] === h["header"]) === -1);
                    if (missedData && missedData.length) {
                        missedData.map(v => {
                            const index = defHead.findIndex(h => h["header"] === v["header"]);
                            if (index > -1) {
                                result.splice(index, 0, v);
                            }
                        });
                    }
                }
            } else if (!frmRxHist) {
                result = this.getDefaultHead(wijimoKey);
            }
        } else if (!frmRxHist) {
            result = this.getDefaultHead(wijimoKey);
        }
        return result;
    }

    getDefaultHead(wijimoKey) {
        let result = null;
        const defHeaders = new DefaultHeaders();
        if (defHeaders && defHeaders[wijimoKey]) {
            result = defHeaders[wijimoKey];
        }
        return result;
    }
    async storeWijimoStatus1(WijmoKey, result) {
         const d = this.getWJSavedData(true);
        let data: WjGridSaveModel = new WjGridSaveModel();
        data["WijmoKey"] = WijmoKey;
        data["WijmoId"] = wijimoIdsList[WijmoKey];
        let wjColData = [];
        if (result) {
            wjColData = result.map(v => {
                const k = {};
                k["header"] = v["header"];
                k["width"] = v["width"];
                k["isVisible"] = v["isVisible"];
                k["minWidth"] = v["minWidth"] ? v["minWidth"] : 50;
                return k;
            });
        }
        data["ColumnOrder"] = JSON.stringify(wjColData);
        await this._comnUtil.saveWjGridDet(data);

    }

    getChildGridHeight(item: any, headerHeight: number = 40, rowHeight: number = 45): string {
        const rowCount = item?.items?.length || 1;
        const padding = 5;
        const height = headerHeight + (rowHeight * rowCount) + padding;
        return `${height}px`;
    }

    /**
     * Export FlexGrid to Excel with built-in protection against multiple rapid clicks
     * @param flex - The FlexGrid instance to export
     * @param fileName - The name of the exported file (e.g., "export.xlsx")
     * @param excludeColumns - Array of column bindings to exclude (e.g., ["Actions", "Select"])
     * @param formatItem - Optional custom format function
     * @param exportDelayMs - Delay in milliseconds before allowing next export (default: 500ms).
     *                        This prevents accidental double-clicks. Set to 0 to disable delay.
     *                        For rapid consecutive exports, consider reducing this value or using UI-level debouncing.
     * @returns Promise that resolves when export completes
     */
    async exportToExcel(
        flex: wjcGrid.FlexGrid,
        fileName: string,
        excludeColumns: string[] = ["Actions", "Select", "Action"],
        formatItem?: (args: any) => void,
        exportDelayMs: number = this.DEFAULT_EXPORT_DELAY_MS
    ): Promise<boolean> {
        // Prevent multiple export operations from rapid clicking
        if (this.isExporting) {
            return false;
        }

        this.isExporting = true;

        try {
            await wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
                flex,
                {
                    includeColumns: function(column) {
                        return (
                            column.binding && 
                            column.isVisible && 
                            !((excludeColumns || []).map((x: any) => x.toUpperCase()).includes(column.binding.toUpperCase()))
                        );
                    }.bind(this),
                    formatItem: (args) => {
                        if (formatItem) {
                            formatItem(args);
                        } else {
                            this._comnUtil.exportFormatItem(args);
                        }

                        // Only for RPH Verification History grid
                        if (fileName === "ReviewPharmacistVerfGrid.xlsx") {

                            const col = args.panel.columns[args.col];

                            if (
                                (args.panel.cellType === wjcGrid.CellType.Cell ||
                                args.panel.cellType === wjcGrid.CellType.ColumnFooter) &&
                                (col.binding === "Billed" || col.binding === "Paid")
                            ) {

                                const numericVal = Number(parseFloat(args.xlsxCell.value || 0).toFixed(2));
                                args.xlsxCell.value = isNaN(numericVal) ? 0 : numericVal;

                                args.xlsxCell.style = args.xlsxCell.style || {};
                                args.xlsxCell.style.format = '"$"#,##0.00';

                                if (args.panel.cellType === wjcGrid.CellType.ColumnFooter) {

                                    args.xlsxCell.style.font = { bold: true };

                                    if (args.col === args.panel.columns.length - 1) {
                                    }

                                    if (col.binding === "Billed") {
                                        const firstCol = args.panel.columns[0];
                                        args.panel.setCellData(args.row, 0, "Total Billed", true);
                                    }

                                    if (col.binding === "Paid") {
                                        const firstCol = args.panel.columns[0];
                                        args.panel.setCellData(args.row, 0, "Total Paid", true);
                                    }
                                }
                            }
                        }
                    }
                },
                fileName
            );

            // Reset flag after export completes
            // Delay prevents accidental double-clicks; can be configured via exportDelayMs parameter
            setTimeout(() => {
                this.isExporting = false;
            }, exportDelayMs);

            return true;
        } catch (error) {
            // Reset flag even if export fails
            this.isExporting = false;
            throw error;
        }
    }

    /**
     * Check if an export operation is currently in progress
     */
    isExportInProgress(): boolean {
        return this.isExporting;
    }
}
